module.exports = __webpack_public_path__ + "static/media/lupabanner_sm2.44d8448c.png";